import React, { useEffect, useState } from "react";
import "./HomeBanner.css";
import OwlCarousel from "react-owl-carousel2";

function HomeBanner() {
  const options = {
    loop: false,
    items: 1,
    dots: false,
    autoplay: true,
    loop: true,
    // autoplay: false,
    autoplayTimeout: 5000,
    nav: false,
  };

  const data = [
    { img: "/img/mobile-banner.jpg" },
    {
      img: "https://plus.unsplash.com/premium_photo-1673953509975-576678fa6710?auto=format&fit=crop&q=80&w=1000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8ZG9jdG9yfGVufDB8fDB8fHww",
    },
  ];

  return (
    <>
      <div className="banner-main">
        <img className="banner-pattern-img" src="/img/banner-pattern.svg" />
        {/* <img className="banner-waves" src="/img/subtract-vector.svg" /> */}
        <img className="banner-waves" src="/img/curve-blue.svg" />
        <div className="banner-cont">
          <div style={{ width: "100%" }}>
            <div className="banner-star">
              <img className="wow fadeInUp" src="/img/stars-top.svg"></img>
            </div>
            <div className="welcome-banner wow bounceInLeft">
              <div className="welcome-arrow">
                <span>Welcome to Sabine</span>
                <img src="/img/arrow-right.svg"></img>
              </div>
              <p className="caring-for wow backInUp">
                Caring for You
                <br />
                Every Step of the Way
              </p>
              <p className="experience-world">
                Experience a world of healthcare excellence with Sabine
                Hospital, where every patient is a family, and well-being
                is our commitment.
              </p>
            </div>
          </div>
        </div>
        {/* <div className="banner-items"> */}
        {/* <div style={{ width: "100%" }}>
            <div className="banner-star">
              <img src="/img/stars-top.svg"></img>
            </div>
            <div className="welcome-banner">
              <div className="welcome-arrow">
                <span>Welcome to Sabine</span>
                <img src="/img/arrow-right.svg"></img>
              </div>
              <p className="caring-for">
                Caring for You
                <br />
                Every Step of the Way
              </p>
              <p className="experience-world">
                Experience a world of healthcare excellence with Sabine
                Hospital, where every patient is family, and well-being is our
                commitment.
              </p>
            </div>
          </div> */}

        {/* <div className="home-doc-image">
                <img src="/img/Hero Image.png" />
            </div> */}
        {/* </div> */}
        <img src="/img/banner-vector.svg" className="banner-items"></img>

        <div className="final-carousel">
          <OwlCarousel options={options}>
            <img className="banner-final-image" src="/img/carousel-one.png" />
            {/* <img className="banner-final-image" src="/img/carousel-four.gif" /> */}
            <img className="banner-final-image" src="/img/carousel-two.png" />
            <img className="banner-final-image" src="/img/carousel-three.png" />
          </OwlCarousel>
        </div>
        {/* <img className="banner-right-image" src="/img/mobile-banner.jpg" /> */}
      </div>

      <div className="mobile-banner-new">
        <img src="/img/mobile-wave-combo.svg" />
        <div className="banner-contents">
          <img className="wow fadeInUp" src="/img/stars-top.svg" />
          <div className="wow bounceInLeft">
            <div className="welcome-sabine-flex">
              <h5 className="wow fadeInUp">Welcome to Sabine</h5>
              <img className="wow fadeInUp" src="/img/arrow-right.svg" />
            </div>

            <h3 className="wow">Caring for You Every Step of the Way</h3>
            <p className="wow">
              Experience a world of healthcare excellence with Sabine Hospital,
              where every patient is a family, and well-being is our commitment.
            </p>
          </div>
        </div>
      </div>

      {/* <img className="wave-vector-svg-top" src="/img/wave-vector.svg" /> */}
      <div className="mobile-banner-pic">
        <OwlCarousel options={options}>
          <div className="item">
            <img
              className="mobile-banner-img"
              src="/img/carousel-one.png"
              alt="Image 1"
            />
          </div>
          <div className="item">
            <img
              className="mobile-banner-img"
              src="/img/carousel-two.png"
              alt="Image 2"
            />
          </div>
          <div className="item">
            <img
              className="mobile-banner-img"
              src="/img/carousel-three.png"
              alt="Image 2"
            />
          </div>
        </OwlCarousel>
        {/* <img className="wave-vector-svg" src="/img/wave-vector.svg" /> */}
      </div>
      {/* <img className="wave-vector" src="/img/wave-vector.svg" /> */}
    </>
  );
}

export default HomeBanner;
